const TwoLineMenuItem = ({ title, subtitle }) => (
  <span className="flex flex-col items-start content-start flex-grow truncate">
    <span className="block max-w-full font-medium leading-snug">{title}</span>
    <span className="block max-w-full text-sm font-normal leading-snug">
      {subtitle}
    </span>
  </span>
);

TwoLineMenuItem.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
};

export default TwoLineMenuItem;
